import type { Locale } from "./locale";

/**
 * Nome de cada idioma escrito nele mesmo — não se traduz: quem procura o
 * próprio idioma numa tela que não entende reconhece "Español", não
 * "Espanhol". É a convenção dos seletores de idioma (sistema, navegador).
 */
export const LOCALE_NAMES: Readonly<Record<Locale, string>> = {
  "pt-BR": "Português",
  "en-US": "English",
  "es-ES": "Español",
};
